import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { cn } from '@/lib/utils';
import { LazyImage } from '@/components/LazyImage';
import { getSearchObjectUrl } from '@/lib/utils/search-object-urls';
import type { ApiSearchObject } from '@/lib/api/types';
interface SearchObjectCardProps {
  result: ApiSearchObject;
  variant?: 'default' | 'compact';
  className?: string;
}
export function SearchObjectCard(t0) {
  const $ = _c(23);
  const {
    result,
    variant: t1,
    className
  } = t0;
  t1 === undefined ? "default" : t1;
  const isItem = result.objectType === "item";
  let t2;
  if ($[0] !== result) {
    t2 = getSearchObjectUrl(result);
    $[0] = result;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const href = t2;
  const brandName = isItem && result.systemData ? (result.systemData as any).brandName : null;
  let t3;
  if ($[2] !== className) {
    t3 = cn("flex items-center gap-3 p-2 hover:bg-gray-50 transition-colors cursor-pointer", className);
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = result.image || "";
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex items-center justify-center bg-gray-100 rounded-md h-12"><span className="text-gray-400 text-xs">No image</span></div>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== result.name || $[6] !== t4) {
    t6 = <div className="flex-shrink-0 w-12 h-12"><LazyImage src={t4} alt={result.name} aspectRatio="1/1" className="rounded-md h-12" objectFit="cover" fallback={t5} /></div>;
    $[5] = result.name;
    $[6] = t4;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== brandName || $[9] !== isItem) {
    t7 = isItem && brandName && <p className="text-[10px] text-gray-500 font-medium uppercase tracking-wide">{brandName}</p>;
    $[8] = brandName;
    $[9] = isItem;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== result.name) {
    t8 = <h3 className="text-sm font-semibold text-gray-900 line-clamp-1">{result.name}</h3>;
    $[11] = result.name;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t7 || $[14] !== t8) {
    t9 = <div className="flex-1 min-w-0">{t7}{t8}</div>;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t3 || $[17] !== t6 || $[18] !== t9) {
    t10 = <div className={t3}>{t6}{t9}</div>;
    $[16] = t3;
    $[17] = t6;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== href || $[21] !== t10) {
    t11 = <Link href={href}>{t10}</Link>;
    $[20] = href;
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
}